import React, {useEffect} from 'react';
import arrow from "../../../../images/down.svg";
import calendar from "../../../../images/calendar.svg";
import {Field} from "formik";
import {fromDateToStringDate, fromStringDateToDate, getFormattedDate, getStringDate} from "../../../../utils";
import {DateRange} from "react-date-range";
import line from "../../../../images/line.svg";
import arrowDown from "../../../../images/input-arrow.svg";
import {roles} from "../../../../redux/types";
import infoIcon from "../../../../images/info-circle.svg";
import ReactTooltip from "react-tooltip";
import {connect} from "react-redux";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {CREW_ROLES} from "../../../../redux/data/data-types";
import {useTranslation} from "react-i18next";
import InputMask from 'react-input-mask';

const TripInfoBlock = ({
                         state, setState, role, days, handleChange, setFieldValue, isTides, miles, nightHours, errors,
                         dateStart, dateFinish, crewRoles, getCommonData, submitCount, setFieldError, tripInfoRef
                       }) => {
  errors = submitCount > 0 ? errors : {}
  const {t} = useTranslation()
  useEffect(() => {
    getCommonData(CREW_ROLES)
  }, [])
  useEffect(() => {
    if(errors.dateStart || errors.dateFinish || errors.role) {
      tripInfoRef.current.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [errors.dateStart, errors.dateFinish, errors.role])
  return (
    <div className="modal__section" ref={tripInfoRef}>
      <input defaultChecked={true} checked={errors.dateStart || errors.dateFinish || errors.role} id={'check'}
             type="checkbox" className={'modal__check'}/>
      <label htmlFor={'check'} className="modal__subTitle">
        <h6 className="modal__underTitle">{t('infoTrip')}</h6>
        <div className="modal__collapse">
          <img src={arrow} alt=""/>
        </div>
      </label>
      <div className="modal__inputs">
        <div className="modal__inputItem">
          <p className="modal__label">{t('dates')}: <span className={'required'}>*</span></p>
          <div className={`modal__date ${(errors.dateStart || errors.dateFinish) && 'modal__inputError'}`}>
            <div className="modal__dateItem">
              <img src={calendar} alt="" className={'mr-12'}/>
              <InputMask mask={'99.99.9999'} maskChar={''} permanents={[2, 5]} placeholder={t('chooseStartDate')}
                         className={'modal__dateInput'} type="text" id={'dateStart'}
                         value={dateStart !== '...' ? dateStart : ''} onChange={(e) => {
                handleChange(e)
                if (e.target.value.length === 10) {
                  if(dateFinish && dateStart) setFieldValue('days', (new Date(dateFinish) - new Date(dateStart)) / (24 * 3600 * 1000))
                  if (/^(0[1-9]|1[0-2])\.(0[1-9]|1\d|2\d|3[01])\.(19|20)\d{2}$/.test(e.target.value)) {
                    let date = e.target.value.split('.')
                    setState([{
                      ...state[0],
                      startDate: new Date(date[2], +date[1] - 1, date[0])
                    }])
                  } else {
                    setFieldError('dateStart', t('invalidDate'))
                  }
                } else {
                  setState([{
                    ...state[0],
                    startDate: null
                  }])
                }
              }} autoComplete={'off'}/>
              <div className="modal__calendar">
                {/*<Calendar onChange={item => {*/}
                {/*  formikProps.setFieldValue('dateStart', item)*/}
                {/*  setFromDate(item)*/}
                {/*}} date={fromDate} maxDate={finishDate ?? null}/>*/}
                <DateRange
                  editableDateInputs={true}
                  onChange={item => {
                    setState([item.selection])
                    setFieldValue('days', (new Date(item.selection.endDate) - new Date(item.selection.startDate)) / (24 * 3600 * 1000))
                    setFieldValue('dateStart', fromDateToStringDate(getFormattedDate(item.selection.startDate)))
                    setFieldValue('dateFinish', fromDateToStringDate(getFormattedDate(item.selection.endDate)))
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={state}
                  months={2}
                  className={'datePicker'}
                  direction={'horizontal'}
                  showDateDisplay={false}
                  rangeColors={['#2196F3']}
                />
              </div>
            </div>
            <img src={line} alt=""/>
            <div className="modal__dateItem">
              <img src={calendar} alt="" className={'mr-12'}/>
              <InputMask mask={'99.99.9999'} maskChar={''} permanents={[2, 5]} className={'modal__dateInput'}
                         type="text" placeholder={t('chooseFinishDate')}
                         value={dateFinish !== '...' ? dateFinish : ''} id={'dateFinish'} autoComplete={'off'}
                         onChange={(e) => {
                           handleChange(e)
                           if (e.target.value.length === 10) {
                             if(dateFinish && dateStart) setFieldValue('days', (new Date(dateFinish) - new Date(dateStart)) / (24 * 3600 * 1000))
                             if (/(0[0-9]|1\d|2\d|3[01])\.(0[0-9]|1[0-2])\.(19|20)\d{2}$/.test(e.target.value)) {
                               let date = e.target.value.split('.')
                               setState([{
                                 ...state[0],
                                 endDate: new Date(date[2], +date[1] - 1, date[0])
                               }])
                             }
                           } else {
                             setState([{
                               ...state[0],
                               endDate: null
                             }])
                           }
                         }}/>
              <div className="modal__calendar">
                <DateRange
                  editableDateInputs={true}
                  onChange={item => {
                    setState([item.selection])
                    setFieldValue('days', (new Date(item.selection.endDate) - new Date(item.selection.startDate)) / (24 * 3600 * 1000))
                    setFieldValue('dateFinish', fromDateToStringDate(getFormattedDate(item.selection.endDate)))
                    setFieldValue('dateStart', fromDateToStringDate(getFormattedDate(item.selection.startDate)))
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={state}
                  months={2}
                  className={'datePicker'}
                  direction={'horizontal'}
                  showDateDisplay={false}
                  rangeColors={['#2196F3']}
                />
              </div>
            </div>
          </div>
        </div>
        {(errors.dateStart || errors.dateFinish) && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.dateStart || errors.dateFinish}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('days')}:</p>
          <div className="modal__inputWrapper">
            <Field id={'days'} value={days}
                   disabled={true}
                   className="modal__input w-130"/>
            <button onClick={() => {
              if (dateStart && dateFinish) {
                let totalDays = (new Date(fromStringDateToDate(dateFinish)) - new Date(fromStringDateToDate(dateStart))) / (24 * 3600 * 1000)
                if (totalDays - 1 !== +days) {
                  setFieldValue('days', `${+days - 1}`)
                }
              }
            }} className="modal__inputControl">
              -
            </button>
            <button onClick={() => {
              if (dateStart && dateFinish) {
                let totalDays = (new Date(fromStringDateToDate(dateFinish)) - new Date(fromStringDateToDate(dateStart))) / (24 * 3600 * 1000)
                if (totalDays + 1 !== +days) {
                  setFieldValue('days', `${+days + 1}`)
                }
              }
            }} className="modal__inputControl">
              +
            </button>
          </div>
        </div>
        <div className="modal__inputItem">
          <p className="modal__label">{t('role')}: <span className={'required'}>*</span></p>
          <div className={`modal__inputWrapper`}>
            <Field autoComplete={'off'} placeholder={t('notChosen')} value={role} id={'role'}
                   onChange={() => {
                   }} type="text" className={`modal__input w-400 ${errors.role && 'modal__inputError'}`}/>
            <button className="modal__arrowIcon">
              <img src={arrowDown} alt=""/>
            </button>
            <div className="modal__list">
              <div className="modal__listItems">
                {crewRoles.map((r, index) => <button className="modal__listItem"
                                                     onClick={() => setFieldValue('role', r.name)} key={index}>
                  {r.name}
                </button>)}
              </div>
            </div>
          </div>
          <button data-tip data-for={'role'} className="modal__infoButton">
            <img src={infoIcon} alt=""/>
          </button>
          <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'role'} place="top" effect="solid">
            {t('yourRole')}
          </ReactTooltip>
        </div>
        {errors.role && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.role}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('tidalRegion')}:</p>
          <div className="modal__checks">
            <div className="modal__checkWrapper">
              <div onClick={() => setFieldValue('isTides', false)}
                   className={`modal__checkbox ${!isTides && 'modal__checkboxSelected'}`}>
                {!isTides && <div className="modal__circle"/>}
              </div>
              <p className="modal__checkboxText">{t('no')}</p>
            </div>
            <div className="modal__checkWrapper">
              <div onClick={() => setFieldValue('isTides', true)}
                   className={`modal__checkbox ${isTides && 'modal__checkboxSelected'}`}>
                {isTides && <div className="modal__circle"/>}
              </div>
              <p className="modal__checkboxText">{t('yes')}</p>
            </div>
          </div>
        </div>
        <div className="modal__inputItem">
          <p className="modal__label">{t('nmPassed')}:</p>
          <div className="modal__inputWrapper">
            <Field onChange={(e) => {
              if (!isNaN(e.target.value) && e.target.value.length < 6) {
                handleChange(e)
              }
            }} placeholder={'0'} value={miles} id={'miles'}
                   className="modal__input"/>
            <button className="modal__arrowIcon">
              <img src={arrowDown} alt=""/>
            </button>
          </div>
        </div>
        <div className="modal__inputItem">
          <p className="modal__label">{t('nightHours')}:</p>
          <div className="modal__inputWrapper">
            <Field placeholder={'0'} id={'nightHours'} value={nightHours}
                   onChange={(e) => {
                     if (!isNaN(e.target.value) && e.target.value.length < 6) {
                       handleChange(e)
                     }
                   }} className="modal__input"/>
            <button className="modal__arrowIcon">
              <img src={arrowDown} alt=""/>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  crewRoles: state.dataReducer.crewRoles
})

export default connect(mapStateToProps, {getCommonData})(React.memo(TripInfoBlock));
